import { Button, Form } from "antd";
import { useFormWizard } from "components/formWizard/formWizardContext";
import styled from "styled-components";

const StyledButton = styled(Button)`
  margin: 0 8px;
`;

const StyledStepsAction = styled.div`
  display: flex;
  justify-content: flex-end;
`;

function ActionBar() {
  const { steps, current, onCancel, isLoading, onPreviousStep } = useFormWizard();

  const { loading: nextLoading, ...restNextButtonProps } = steps[current]?.nextButtonProps ?? {};
  const { loading: doneLoading, ...restDoneButtonProps } = steps[current]?.doneButtonProps ?? {};

  return (
    <Form.Item>
      <StyledStepsAction>
        {current === 0 ? (
          <StyledButton onClick={onCancel} htmlType="button" {...steps[current]?.cancelButtonProps}>
            Cancel
          </StyledButton>
        ) : (
          <StyledButton
            onClick={onPreviousStep}
            htmlType="button"
            {...steps[current]?.previousButtonProps}
          >
            Previous
          </StyledButton>
        )}
        {current < steps.length - 1 ? (
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading || nextLoading}
            {...restNextButtonProps}
          >
            Next
          </Button>
        ) : (
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading || doneLoading}
            {...restDoneButtonProps}
          >
            {steps[current]?.doneButtonText || "Done"}
          </Button>
        )}
      </StyledStepsAction>
    </Form.Item>
  );
}

export default ActionBar;
